import React, { Component } from 'react'
import PropTypes from 'prop-types'
import uuid from 'uuid'
import { withRouter } from 'react-router'
import { reduxForm, reset, getFormValues } from 'redux-form'
import { push } from 'connected-react-router'
import { connect } from 'react-redux'

function decorator(config) {
    return ComposedComponent => {
        @reduxForm(
            {
                form: config.form,
                destroyOnUnmount: !config.persist
            },
            { reset }
        )
        @connect(state => ({
                settingFormValues: getFormValues(config.form)(state)
            }),
            { push })
        @withRouter
        class Setting extends Component {
            static propTypes = {
                setSettings: PropTypes.func.isRequired,
                query: PropTypes.string,
                change: PropTypes.func,
                handleSubmit: PropTypes.func,
                initialize: PropTypes.func,
                destroy: PropTypes.func,
                push: PropTypes.func,
                options: PropTypes.object,
                router: PropTypes.object,
                routes: PropTypes.array,
                location: PropTypes.object,
                reset: PropTypes.func,
                route: PropTypes.object
            }

            componentDidMount() {
            }

            componentWillUnmount = () => {
                if (!config.persist) {
                    this.props.setSettings(null)
                    this.props.destroy(config.form)
                }
            }

            key = uuid.v1()

            handleCreateQueryPart = fields => {
                const queryPart = this.prepareQueryPart(fields)

                this.handleSetSettings(queryPart, fields)
            }

            handleSetSettings = queryPart => {
                this.props.setSettings(queryPart)
            }

            prepareQueryPart = fields => {
                if (!fields) {
                    return ''
                }

                let queryPart = ''

                let idx = 0

                for (const [key, value] of Object.entries(fields)) {
                    queryPart += `${key}=${value}`

                    if (idx > 0) {
                        queryPart += '&'
                    }

                    idx++
                }

                return queryPart
            }
            render() {
                const { handleSubmit } = this.props

                return (
                    <form key={this.key} onSubmit={handleSubmit(this.handleCreateQueryPart)}>
                        <ComposedComponent
                            {...this.props}
                            setSettings={this.handleSetSettings}
                        />
                    </form>
                )
            }
        }

        return Setting
    }
}

export default decorator
